import React, { createContext, useContext, useState, useEffect } from 'react';

import api from '../../modules/api';
import { useParams } from 'react-router-dom';

const UserContext = createContext();

const getUserGithubReadme = async (gitUsername) => {
  const repoUrl = `https://raw.githubusercontent.com/${gitUsername}/${gitUsername}/main/README.md`;

  try {
    const response = await fetch(repoUrl);
    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
    return response.text();
  }
  catch (err) {
    return 'Could not load github profile';
  }
}

export function UserProvider({ children }) {
  const [userData, setUserData] = useState({});
  const { username } = useParams();

  useEffect(() => {
    // get all of the user's public entities
    api.user.getPublicProfile({ username })
      .then((user) => {
        setUserData(user);
        getUserGithubReadme(user.githubUsername)
          .then(content => {
            setUserData(prevData => ({
              ...prevData,
              bio: content,
            }));
          });
        api.user.getPublicEntities({ username })
          .then(entities => {
            setUserData(prevData => ({
              ...prevData,
              entities: entities,
            }));
          });
      })
  }, [username]);

  const value = {
    userData,
    setUserData,
  };

  console.log('user context', value);

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
}

export function useUserContext() {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
} 